<div class=" criteria-container p-3">
    <div class="row">
        <div class="col">
            <form novalidate class="pr-2" [formGroup]="form">
                <div class="d-flex d-row">
                    <div class="flex-grow-1">
                        <input class="form-control" type="text" formControlName="name"
                            placeholder="{{ 'GroupClassListCriteria.NameFieldPlaceholder' | translate }}" />
                    </div>

                    <div>
                        <button type="button" (click)="clearFilters()" class="btn bc-button btn-clear btn-sm mr-2"
                            translate [disabled]="!context">
                            GroupClassListCriteria.ClearBtn
                        </button>

                        <button *ngIf="!advancedFilters" type="button" (click)="changeTypeOfFilters()"
                            class="btn bc-button btn-filters btn-sm" translate [disabled]="!context">
                            GroupClassListCriteria.BtnShowFilters
                        </button>
                        <button *ngIf="advancedFilters" type="button" (click)="changeTypeOfFilters()"
                            class="btn bc-button btn-filters btn-sm" translate>
                            GroupClassListCriteria.BtnHideFilters
                        </button>
                    </div>
                </div>
                <div *ngIf="advancedFilters" class="form-group d-flex d-row pt-3">
                    <div class="col-3 pl-0 pr-3">
                        <label translate>GroupClassListCriteria.LabelClub</label>
                        <bcu-drop-down-cf2 [selectAll]="true" placeHolder="All" [multiple]="true" [options]="clubs"
                            maxHeigth="450" formControlName="clubs" valueKey="id" displayKey="shortName"
                            textAlign="left" [sortItems]="true"></bcu-drop-down-cf2>
                    </div>
                    <div class="col-3 pl-2 pr-3">
                        <label translate>GroupClassListCriteria.LabelCategory</label>
                        <bcu-group-drop-down placeHolder="All" [multiple]="true" maxHeigth="450"
                            formControlName="categories" [options]="categories" valueKey="code"
                            groupByKey="classTypeName" displayKey="name"></bcu-group-drop-down>
                    </div>
                    <div class="col-3 pl-2 pr-3">
                        <label translate>GroupClassListCriteria.LabelStatus</label>
                        <bcu-drop-down-cf2 [selectAll]="true" placeHolder="All" [multiple]="true" formControlName="statuses"
                            [options]="context.statuses" valueKey="code" displayKey="name" textAlign="left"
                            [sortItems]="true"></bcu-drop-down-cf2>
                    </div>
                    <div class="col-3 pl-2">
                        <label translate>GroupClassListCriteria.LabelInstructor</label>
                        <input class="form-control" type="text" formControlName="instructor"
                            placeholder="{{ 'GroupClassListCriteria.InstructorFieldPlaceholder' | translate }}" />
                    </div>
                </div>
                <div *ngIf="advancedFilters" class="form-group d-flex d-row pt-1 mb-0">
                    <div class="col-3 pl-0 pr-3">
                        <label translate>GroupClassListCriteria.LabelDateFrom</label>
                        <bcu-drop-down-button-cf2 [text]="form.controls['dateFrom'].value | bcDate"
                            (click)="dateFromPicker.toggle($event)" textAlign="left"></bcu-drop-down-button-cf2>
                        <bcu-date-select [canSelectPastDates]="true" #dateFromPicker formControlName="dateFrom">
                        </bcu-date-select>
                    </div>
                    <div class="col-3 pl-2 pr-3">
                        <label translate>GroupClassListCriteria.LabelDateTo</label>
                        <bcu-drop-down-button-cf2 [text]="form.controls['dateTo'].value | bcDate"
                            (click)="dateToPicker.toggle($event)" textAlign="left"></bcu-drop-down-button-cf2>
                        <bcu-date-select [canSelectPastDates]="true" #dateToPicker formControlName="dateTo">
                        </bcu-date-select>
                    </div>
                    <div class="col-4 align-self-center align-items-center pl-2">
                        <div class="switch-container">
                            <ui-switch [checked]="form.controls['onlyBookingRequired'].value"
                                (change)="onlyBookingRequiredChanged($event)" class="switch" color="#346ABC"
                                size="small" switchColor="#E5E5E5">
                            </ui-switch><span class="ml-1 check-text"
                                translate>GroupClassListCriteria.OnlyBookingRequired</span>
                        </div>
                    </div>
                </div>

                <div *ngIf="advancedFilters" class="form-group d-flex d-row pt-3 mb-0">
                    <div class="col-3 pl-0 pr-3">
                        <label translate>GroupClassListCriteria.OnlineLabel</label>
                        <bcu-drop-down-cf2 [selectAll]="true" placeHolder="All" [multiple]="false" formControlName="online"
                            [options]="onlineOptions" valueKey="code" displayKey="name" textAlign="left"
                            [sortItems]="false"></bcu-drop-down-cf2>
                    </div>

                    <div class="col-3 pl-2 pr-3">
                        <label translate>GroupClassListCriteria.IsVisibleToConnectLabel</label>
                        <bcu-drop-down-cf2 [selectAll]="true" placeHolder="All" [multiple]="false"
                            formControlName="isVisibleToConnect" [options]="isVisibleToConnectOptions" valueKey="code"
                            displayKey="name" textAlign="left" [sortItems]="false"></bcu-drop-down-cf2>
                    </div>

                    <div class="col-4 align-self-center align-items-center pl-2">
                        <div class="switch-container">
                            <ui-switch [checked]="form.controls['substitutedOnly'].value"
                                (change)="onlySubstitutedChanged($event)" class="switch" color="#346ABC" size="small"
                                switchColor="#E5E5E5">
                            </ui-switch><span class="ml-1 check-text"
                                translate>GroupClassListCriteria.SubstitutionOnly</span>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
